var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Header',{staticClass:"header"},[_c('div',{class:_vm.headerClass},[_c('div',{staticClass:"logo"},[_vm._t("header-left")],2),_c('div',{staticClass:"main-opts"},[_vm._t("header-right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }